import React, { useState } from 'react'
import { useTransition, animated } from 'react-spring'

const PageWrapper = ({ children }) => {
  const [show] = useState(true)
  const transitions = useTransition(show, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 }
  })

  return transitions.map(
    ({ item, key, props }) =>
      item && (
        <animated.div key={key} style={props}>
          {children}
        </animated.div>
      )
  )
}

export default PageWrapper
